<template>
  <Button class="button-rounded shadow" @click="$emit('click')"><slot></slot></Button>
</template>
<script>
export default {
  name: 'ButtonRounded'
};
</script>
<style lang="scss" scoped>
.button-rounded {
  background-color: transparent;
  border: 2px solid var(--color-primary);
  color: var(--color-primary);
  text-align: center;
  text-decoration: none;
  font-size: 16px;
  border-radius: 50%;
  height: 3rem;
  aspect-ratio: 1/1;
  display: grid;
  place-content: center;
}
::v-deep span {
  display: block;
}
</style>
